export interface TranslationProps {
  locale: string;
  name: string;
  description?: string;
}

export class Translation {
  readonly locale: string;
  readonly name: string;
  readonly description?: string;

  private constructor(props: TranslationProps) {
    this.locale = props.locale;
    this.name = props.name;
    this.description = props.description;
  }

  static of(props: TranslationProps): Translation {
    return new Translation(props);
  }
}
